import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const AddressStep = ({ formData, errors, handleInputChange }) => {
  return (
    <div className="space-y-6 md:space-y-8">
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 md:p-6">
        <div className="flex gap-3 md:gap-4">
          <div className="flex-shrink-0">
            <Icon name="MapPin" size={24} color="var(--color-accent)" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-2 text-sm md:text-base lg:text-lg">
              Site Location
            </h3>
            <p className="text-sm md:text-base text-muted-foreground">
              Provide the full address where construction work will take place. This helps with document organization and compliance tracking.
            </p>
          </div>
        </div>
      </div>
      <div className="space-y-4 md:space-y-6">
        <Input
          label="Address Line 1"
          type="text"
          name="addressLine1"
          placeholder="Building number and street name"
          value={formData?.addressLine1}
          onChange={handleInputChange}
          error={errors?.addressLine1}
          required
        />

        <Input
          label="Address Line 2"
          type="text"
          name="addressLine2"
          placeholder="Area or district (optional)"
          value={formData?.addressLine2}
          onChange={handleInputChange}
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          <Input
            label="Town/City"
            type="text"
            name="city"
            placeholder="e.g., Manchester"
            value={formData?.city}
            onChange={handleInputChange}
            error={errors?.city}
            required
          />

          <Input
            label="County"
            type="text"
            name="county"
            placeholder="e.g., Greater Manchester"
            value={formData?.county}
            onChange={handleInputChange}
          />
        </div>

        <Input
          label="Postcode"
          type="text"
          name="postcode"
          placeholder="e.g., M1 2AB"
          value={formData?.postcode}
          onChange={handleInputChange}
          error={errors?.postcode}
          required
          description="UK postcode format required"
        />
      </div>
    </div>
  );
};

export default AddressStep;